/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Referral {
    angular.module("meevo.plugins.referral", []);
}